import React from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormInput,
  CFormLabel,
  CButton,
  CAlert
} from '@coreui/react';
import { useTranslation } from 'react-i18next';

const AdminSettings = () => {
  const { t } = useTranslation();
  const [settings, setSettings] = React.useState({
    siteName: 'Vroomies',
    maintenanceMode: false,
    maxCarpoolMembers: 10
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement settings save
    alert(t('profile.updateSuccess'));
  };

  return (
    <div className="admin-settings">
      <CCard>
        <CCardHeader>
          <h2 className="admin-page-title mb-0">{t('profile.settings')}</h2>
        </CCardHeader>
        <CCardBody>
          <CForm onSubmit={handleSubmit}>
            <div className="mb-3">
              <CFormLabel>{t('admin.siteName') || 'Site Name'}</CFormLabel>
              <CFormInput
                type="text"
                value={settings.siteName}
                onChange={(e) => setSettings({...settings, siteName: e.target.value})}
              />
            </div>

            <div className="mb-3">
              <CFormLabel>{t('admin.maxCarpoolMembers') || 'Max Carpool Members'}</CFormLabel>
              <CFormInput
                type="number"
                value={settings.maxCarpoolMembers}
                onChange={(e) => setSettings({...settings, maxCarpoolMembers: parseInt(e.target.value)})}
              />
            </div>

            <CButton type="submit" color="primary">
              {t('common.save')}
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default AdminSettings;

